import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';

// Month of reference, e.g. "2026-09"
export type Month = string;

// Selected month shared by the Finances and Investments screens
@Injectable({
  providedIn: 'root'
})
export class MonthService {

  readonly month$ = new BehaviorSubject<Month>(moment().format('YYYY-MM'));

  get month(): Month {
    return this.month$.value;
  }

  set(month: Month): void {
    this.month$.next(month);
  }

  shift(months: number): void {
    this.set(shiftMonth(this.month, months));
  }
}

export function shiftMonth(month: Month, months: number): Month {
  return moment(month, 'YYYY-MM').add(months, 'months').format('YYYY-MM');
}

// "Setembro de 2026": only the month name is capitalized
export function monthLabel(month: Month): string {
  const label = moment(month, 'YYYY-MM').locale('pt-br').format('MMMM [de] YYYY');
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function monthOf(date: Date): Month {
  return moment(date).format('YYYY-MM');
}

// "2026-09" -> "set", for chart axes
export function monthShort(month: Month): string {
  return moment(month, 'YYYY-MM').locale('pt-br').format('MMM').replace('.', '');
}
